import { render } from "./SuggestionsCard.vue?vue&type=template&id=44dcd119&scoped=true"
import script from "./SuggestionsCard.vue?vue&type=script&lang=js"
export * from "./SuggestionsCard.vue?vue&type=script&lang=js"

import "./SuggestionsCard.vue?vue&type=style&index=0&id=44dcd119&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dcd119"]])

export default __exports__